import { BuildNode, NodeStates } from "@common/build/types";

export const getValueAtPath = (obj: any, path: (string | number)[]): any => {
    return path.reduce((acc: any, key: any) => {
        if (acc && typeof acc === "object" && key in acc) {
            return acc[key];
        }
        return null;
    }, obj);
};

export const getRotateValue = (value?: string) => {
    if (!value) return "0";

    const match = value.match(/rotate\((\d+\.?\d*)deg\)/);

    if (match) {
        const angle = match[1];
        return angle;
    } else {
        return "0";
    }
};

export const getStyle = (node: BuildNode, path?: (string | number)[], nodeState?: NodeStates, cvIndex?: number | null) => {
    const style: { default?: any; stateStyle?: any } = {};
    if (typeof cvIndex === "number" && node.conditionalVariations && node.conditionalVariations.length > cvIndex) {
        if (path) {
            style.default = getValueAtPath(node.conditionalVariations[cvIndex].nodeProps, path) || {};
        } else {
            style.default = node.conditionalVariations[cvIndex].nodeProps?.attr?.style || {};
        }
    } else if (nodeState) {
        if (path) {
            style.stateStyle = node.stateManager?.[nodeState]?.[path.join("_")] || {};
        } else {
            style.stateStyle = node.stateManager?.[nodeState]?.attr_style || {};
        }
    } else {
        if (path) {
            style.default = getValueAtPath(node, path) || {};
        } else {
            style.default = node.attr?.style || {};
        }
    }

    return style;
};

export const getStylePath = (path?: (string | number)[], nodeState?: NodeStates, cvIndex?: number | null) => {
    if (typeof cvIndex === "number") {
        if (path) {
            return ["conditionalVariations", cvIndex, "nodeProps", ...path];
        } else {
            return ["conditionalVariations", cvIndex, "nodeProps", "attr", "style"];
        }
    }
    if (nodeState) {
        if (path) {
            return ["stateManager", nodeState, path.join("_")];
        } else {
            return ["stateManager", nodeState, "attr_style"];
        }
    } else if (path) {
        return path;
    } else {
        return ["attr", "style"];
    }
};
